module.exports = __webpack_public_path__ + "img/bj.50871c6c.png";